import { Injectable } from '@angular/core';
import {
  DodajOdbiorceDoGrupyOdbiorcowRequest,
  EdytujGrupeOdbiorcowRequest,
  GrupaOdbiorcowDto,
  GrupaOdbiorcowDtoQueryParams,
  GrupaOdbiorcowOdbiorcaDto,
  StworzGrupeOdbiorcowRequest,
  UsunGrupeOdbiorcowRequest,
  UsunOdbiorceZGrupyOdbiorcowRequest,
} from '@interfaces/komunikacja/grupa-odbiorcow.interface';
import { PageQueryParams } from '@interfaces/params.interface';
import { INewRecord, IPaginatedData } from '@interfaces/response.interface';
import { ApiBaseService } from '@services/api-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GrupyOdbiorcowService extends ApiBaseService {
  private readonly endpoint = `${this.apiUrl}/komunikacja/wiadomosci/grupy-odbiorcow`;

  getRecord(id: string): Observable<GrupaOdbiorcowDto> {
    return this.http.get<GrupaOdbiorcowDto>(`${this.endpoint}/${id}`);
  }

  getRecords(queryParams?: GrupaOdbiorcowDtoQueryParams): Observable<IPaginatedData<GrupaOdbiorcowDto>> {
    return this.http.get<IPaginatedData<GrupaOdbiorcowDto>>(this.endpoint, {
      params: this.createQueryParams(queryParams),
    });
  }

  saveGrupaOdbiorcow(data: StworzGrupeOdbiorcowRequest): Observable<INewRecord> {
    return this.http.post<INewRecord>(this.endpoint, data);
  }

  updateGrupaOdbiorcow(grupaOdbiorcowId: string, data: EdytujGrupeOdbiorcowRequest): Observable<null> {
    return this.http.put<null>(`${this.endpoint}/${grupaOdbiorcowId}`, data);
  }

  delete(body: UsunGrupeOdbiorcowRequest) {
    return this.http.delete(`${this.endpoint}`, { body });
  }

  getOdbiorcyGrupyOdbiorcow(
    groupId: string,
    queryParams?: PageQueryParams,
  ): Observable<IPaginatedData<GrupaOdbiorcowOdbiorcaDto>> {
    return this.http.get<IPaginatedData<GrupaOdbiorcowOdbiorcaDto>>(`${this.endpoint}/${groupId}/odbiorcy`, {
      params: this.createQueryParams(queryParams),
    });
  }

  addOdbiorcaGrupyOdbiorcow(groupId: string, data: DodajOdbiorceDoGrupyOdbiorcowRequest): Observable<null> {
    return this.http.post<null>(`${this.endpoint}/${groupId}/dodaj-odbiorce`, data);
  }

  deleteOdbiorcaGrupyOdbiorcow(groupId: string, body: UsunOdbiorceZGrupyOdbiorcowRequest) {
    return this.http.delete(`${this.endpoint}/${groupId}/usun-odbiorce`, { body });
  }
}
